// ============================================
// EmployeeStatusDot Component
// Status dot + label for Active/On Leave
// ============================================

import { cn } from '../../../utils/cn';
import { useI18n } from '../../../i18n';

// ============================================
// Types
// ============================================

export type EmployeeStatus = 'active' | 'on_leave';

interface EmployeeStatusDotProps {
  status: EmployeeStatus;
  className?: string;
}

// ============================================
// Styles
// ============================================

const statusConfig: Record<
  EmployeeStatus,
  { dotColor: string; textColor: string; labelKey: string }
> = {
  active: {
    dotColor: 'bg-[#10B981]',
    textColor: 'text-[#047857]',
    labelKey: 'active',
  },
  on_leave: {
    dotColor: 'bg-[#F59E0B]',
    textColor: 'text-[#B45309]',
    labelKey: 'onLeave',
  },
};

// ============================================
// Component
// ============================================

export function EmployeeStatusDot({ status, className }: EmployeeStatusDotProps) {
  const { t } = useI18n();
  const config = statusConfig[status];

  return (
    <div className={cn('flex items-center gap-2', className)}>
      <span
        className={cn(
          'inline-block rounded-full',
          status === 'active' ? 'h-2 w-2' : 'h-1.5 w-1.5',
          config.dotColor
        )}
      />
      <span className={cn('text-xs font-bold', config.textColor)}>
        {t(config.labelKey)}
      </span>
    </div>
  );
}
